// extracted by mini-css-extract-plugin
module.exports = {"icon":"apply-now_icon__n4F2g","subtextClassName":"apply-now_subtextClassName__V9SPk"};